module.exports = __webpack_public_path__ + "static/media/iconHashtag.204afe10.svg";